/**
 * FBT Mobile Fix - Version finale (respecte config desktop de l'app)
 */

(function() {
  'use strict';
  
  console.log('🚀 FBT Mobile Fix - Version finale chargée');
  
  const CONFIG = {
    mobileBreakpoint: 767,
    maxRetries: 20,
    retryDelay: 800,
    
    widgetSelectors: [
      '.lb-upsell-widget',
      '.lb-embed',
      '.lb-bundle',
      '[class*="lb-upsell"]',
      '[id*="lb-upsell"]',
    ],
    
    descriptionSelectors: [
      '#collapse-tab1',
      '.product-description-full',
      '.product-description',
      '.product__description',
      '#product-description',
    ]
  };
  
  let retryCount = 0;
  let widgetMoved = false;
  let anchorCreated = false;
  let originalParent = null;
  let originalNextSibling = null;
  
  function isMobile() {
    return window.innerWidth <= CONFIG.mobileBreakpoint;
  }
  
  /**
   * Force l'affichage des tabs cachés
   */
  function forceShowTabs() {
    const hiddenTabs = document.querySelectorAll('.tab-pane:not(.active)');
    hiddenTabs.forEach(tab => {
      const hasWidget = tab.querySelector('.lb-upsell-widget, .lb-embed');
      if (hasWidget) {
        console.log('📂 Onglet caché avec widget détecté');
        tab.style.display = 'block';
        tab.style.visibility = 'visible';
        tab.classList.add('show', 'active');
      }
    });
  }
  
  /**
   * Crée le conteneur mobile
   */
  function createMobileAnchor() {
    if (anchorCreated) {
      return document.getElementById('fbt-widget-mobile-anchor');
    }
    
    let descriptionElement = null;
    for (let selector of CONFIG.descriptionSelectors) {
      descriptionElement = document.querySelector(selector);
      if (descriptionElement) {
        console.log('✅ Description trouvée avec:', selector);
        break;
      }
    }
    
    if (!descriptionElement) {
      console.warn('⚠️ Description non trouvée');
      return null;
    }
    
    const anchor = document.createElement('div');
    anchor.id = 'fbt-widget-mobile-anchor';
    anchor.className = 'fbt-mobile-positioning';
    anchor.style.cssText = 'display: block !important; width: 100%; margin: 30px 0; clear: both; position: relative;';
    
    // Insère APRÈS la description (nextSibling)
    if (descriptionElement.parentNode) {
      descriptionElement.parentNode.insertBefore(anchor, descriptionElement.nextSibling);
      console.log('✅ Conteneur mobile créé APRÈS la description');
      anchorCreated = true;
      return anchor;
    }
    
    return null;
  }
  
  /**
   * Trouve le widget
   */
  function findWidget() {
    forceShowTabs();
    
    for (let selector of CONFIG.widgetSelectors) {
      const widget = document.querySelector(selector);
      if (widget) {
        console.log('✅ Widget trouvé:', selector);
        return widget;
      }
    }
    
    return null;
  }
  
  /**
   * Repositionne UNIQUEMENT sur mobile
   */
  function repositionWidget() {
    if (widgetMoved) {
      return true;
    }
    
    // Sur desktop, ne fait rien (laisse l'app gérer)
    if (!isMobile()) {
      console.log('ℹ️ Mode desktop - Positionnement géré par l\'app');
      return true;
    }
    
    const mobileAnchor = createMobileAnchor();
    if (!mobileAnchor) {
      console.warn('⚠️ Impossible de créer l\'ancrage mobile');
      return false;
    }
    
    const widget = findWidget();
    if (!widget) {
      console.warn('⚠️ Widget non trouvé (tentative ' + (retryCount + 1) + ')');
      return false;
    }
    
    // Trouve le widget root complet
    let widgetRoot = widget.closest('.lb-upsell-widget') || widget;
    
    // Sauvegarde la position d'origine (pour restauration desktop)
    if (!originalParent) {
      originalParent = widgetRoot.parentNode;
      originalNextSibling = widgetRoot.nextSibling;
      console.log('💾 Position originale sauvegardée');
    }
    
    // Vérifie si déjà positionné
    if (mobileAnchor.contains(widgetRoot)) {
      console.log('✅ Widget déjà positionné');
      widgetMoved = true;
      return true;
    }
    
    try {
      console.log('📦 Déplacement du widget vers APRÈS la description...');
      
      // Déplace le widget
      mobileAnchor.appendChild(widgetRoot);
      
      // Force l'affichage
      widgetRoot.style.display = 'block';
      widgetRoot.style.visibility = 'visible';
      widgetRoot.style.opacity = '1';
      
      console.log('✅ Widget repositionné avec succès APRÈS la description !');
      console.log('🎉 PROBLÈME RÉSOLU sur mobile');
      
      widgetMoved = true;
      return true;
      
    } catch (error) {
      console.error('❌ Erreur:', error);
      return false;
    }
  }
  
  /**
   * Restaure la position d'origine sur desktop
   */
  function restoreOriginalPosition() {
    if (!widgetMoved || !originalParent) {
      return;
    }
    
    const widget = findWidget();
    if (!widget) return;
    
    const widgetRoot = widget.closest('.lb-upsell-widget') || widget;
    
    try {
      console.log('🔄 Restauration position desktop (gérée par l\'app)');
      
      if (originalNextSibling) {
        originalParent.insertBefore(widgetRoot, originalNextSibling);
      } else {
        originalParent.appendChild(widgetRoot);
      }
      
      widgetMoved = false;
      
      console.log('✅ Position desktop restaurée');
      
    } catch (error) {
      console.error('❌ Erreur restauration:', error);
    }
  }
  
  /**
   * Retry
   */
  function retryRepositioning() {
    if (repositionWidget()) {
      return;
    }
    
    if (retryCount < CONFIG.maxRetries) {
      retryCount++;
      setTimeout(retryRepositioning, CONFIG.retryDelay);
    } else {
      console.info('Widget non trouvé après ' + CONFIG.maxRetries + ' tentatives');
    }
  }
  
  /**
   * Gère le changement de taille d'écran
   */
  function handleResize() {
    const nowMobile = isMobile();
    
    if (nowMobile && !widgetMoved) {
      console.log('📱 Passage en mode mobile');
      retryCount = 0;
      repositionWidget();
    } else if (!nowMobile && widgetMoved) {
      console.log('🖥️ Passage en mode desktop');
      restoreOriginalPosition();
    }
  }
  
  /**
   * Initialisation
   */
  function init() {
    console.log('🎯 Initialisation FBT Mobile Fix');
    console.log('📱 Largeur:', window.innerWidth + 'px');
    console.log('📱 Mobile?', isMobile());
    
    forceShowTabs();
    repositionWidget();
    
    setTimeout(retryRepositioning, 1000);
    setTimeout(retryRepositioning, 2000);
    setTimeout(retryRepositioning, 4000);
    
    // Gère le redimensionnement
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 300);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  window.addEventListener('load', function() {
    console.log('📄 Page chargée');
    if (!widgetMoved && isMobile()) {
      setTimeout(retryRepositioning, 1500);
    }
  });
  
})();
